// extracted by mini-css-extract-plugin
module.exports = {"properties-content":"Properties_properties-content__2dYwT","chart-content":"Properties_chart-content__3xOTF"};